import { render, staticRenderFns } from "./Workplaces.vue?vue&type=template&id=7c91c9b6"
import script from "./Workplaces.vue?vue&type=script&lang=ts"
export * from "./Workplaces.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports